import { Component, HostBinding, Input, OnInit } from "@angular/core";

@Component({
  selector: "th[resizable]",
  templateUrl: "./resizable.component.html",
  styleUrls: ["./resizable.component.scss"]
})
export class ResizableComponent implements OnInit {

  @Input() defaultWidth: number = 180;
  @HostBinding("style.width.px")
  width: number | null = null;

  ngOnInit() {
    this.resetWidth();
  }

  resetWidth() {
    this.width = this.defaultWidth;
  }

  onResize(newWidth: any) {
    this.width = newWidth;
  }
}
